import { CadastroBem } from './../models/cadastro-bem';
import { Arquivo } from './../models/arquivo';
import { catchError } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable} from '@angular/core';

import { environment as env } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private readonly PATH = '/Arquivo';
  private readonly PATH_EVIDENCIA = '/Arquivo/Evidencia/';
  private readonly PATH_ABRIR = '/Arquivo/Abrir/';
  

  constructor(private http: HttpClient) { }
  
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json' 
    }),
  };


  upload(formData:FormData):Observable<any>{
    return this.http.post(env.baseurl + this.PATH,formData,this.httpOptions)

  }

  upload_getById(nR_BPM_BEM_PATRIMONIAL:number):Observable<any>{
    return this.http.get(env.baseurl + this.PATH + '/' + nR_BPM_BEM_PATRIMONIAL)
  }

  update(cD_BPM_BEM_PATRIMONIAL:number,arquivo:Arquivo[]):Observable<any>{
    return this.http.put(env.baseurl + this.PATH + '/'+ cD_BPM_BEM_PATRIMONIAL,arquivo,{responseType:'text',headers:{'Content-Type': 'application/json'}})
  }
  delete(NR_BPM_BEM_PATRIMONIAL:number,cD_BPM_ARQUIVO_PATRIMONIAL:number):Observable<any>{
    return this.http.delete(env.baseurl + this.PATH + '?'+ 'NR_BPM_BEM_PATRIMONIAL='+ NR_BPM_BEM_PATRIMONIAL + '&'+'CD_BPM_ARQUIVO_PATRIMONIAL=' + cD_BPM_ARQUIVO_PATRIMONIAL,{responseType:'text'} )
  }
  
  upload_evidencia(NR_BPM_BEM_PATRIMONIAL:number,arquivo:any):Observable<any> {
    return this.http.post(env.baseurl + this.PATH_EVIDENCIA + NR_BPM_BEM_PATRIMONIAL,arquivo)

  }
  upload_abrir(dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL:any):Observable<any>{
    return this.http.get(env.baseurl + this.PATH_ABRIR + dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL,{responseType:'text'})
    
  }
  upload_tratamento(NR_BPM_BEM_PATRIMONIAL:number,cD_BPM_ARQUIVO_PATRIMONIAL:number):Observable<any>{
    return this.http.get(
      env.baseurl + this.PATH +'/'+ NR_BPM_BEM_PATRIMONIAL+'/'+cD_BPM_ARQUIVO_PATRIMONIAL,{responseType:'text'}
      );
  };
}
